import * as React from "react";
import { ReactComponent as LogoStackedSvg } from "./logo-stacked.svg";
import { ReactComponent as LogoHorizontalSvg } from "./logo-horizontal.svg";
import { ReactComponent as LogoMarkSvg } from "./logo-mark.svg";
import { ReactComponent as LogoTextSvg } from "./logo-text.svg";

/**
 * Logo-Marke (nur das Icon) – ideal für die Navbar.
 */
export function LogoMark(props) {
  return <LogoMarkSvg width={40} height={40} {...props} />;
}

/**
 * Horizontales Logo (Icon + Text nebeneinander) – ideal für Footer oder größere Darstellungen.
 * Berechnet die Breite automatisch aus der Höhe (ViewBox-Verhältnis 967:288).
 */
export function LogoHorizontal({ height = 40, ...props }) {
  return <LogoHorizontalSvg height={height} width={Math.round(height * (967 / 288))} {...props} />;
}

/**
 * Gestapeltes Logo (Icon über Text) – ideal für Hero-Bereiche oder Sidebars.
 */
export function LogoStacked(props) {
  return <LogoStackedSvg height={80} {...props} />;
}

/**
 * Nur-Text-Logo – für compacte Kontexte.
 */
export function LogoText(props) {
  return <LogoTextSvg height={30} {...props} />;
}

/** Standard-Export: LogoMark (Navbar-kompatibel) */
export default LogoMark;
